<template>
  <div class="carousel_wrap">
    <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.imageUrl" alt="" class="img_item" />
        <div class="tips_font">
          <h1 v-html="item.title"></h1>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.imageUrl" alt="" class="img_item" />
        <div class="tips_font">
          <h1 v-html="item.title"></h1>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getHomeBanner } from '../../api/system'
export default {
  data() {
    return {
      imgList: [],
    }
  },
  methods: {
    async getHomeBannerFunc() {
      const res = await getHomeBanner()
      if (res.data) {
        this.imgList = res.data.data;
      }
    }
  },
  mounted() {
    this.getHomeBannerFunc()
  }
}
</script>

<style lang="scss">
.carousel_wrap {
  position: relative;

  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-size: 25px;

    @media screen and (max-width: 768px) {
      width: 90%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      font-size: 0.75rem;
    }
  }
}
</style>